var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.external)?_c('li',[_c('a-link',{attrs:{"to":_vm.linkTo}},[_vm._v(_vm._s(_vm.title))])],1):_c('li',[_c('text-button',{attrs:{"text":_vm.title,"linkStyle":"white-link"},on:{"click":_vm.onClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }